import React from "react";
import { Card, Col, Row } from "react-bootstrap";

import { StatsProps } from "@Leagues/types/leagues";

const Stats = (props: StatsProps): React.JSX.Element => {
    const { standingsData } = props;

    return (
        <Row className="mb-4 team-stats">
            <h2 className="section-title">Team Averages</h2>
            <Col md={4} sm={6} className="mb-3">
                <Card className="stats-card text-center">
                    <div className="stat-number">
                        {standingsData?.rsavg || 0}
                    </div>
                    <div className="stat-label">Average Runs Scored</div>
                </Card>
            </Col>
            <Col md={4} sm={6} className="mb-3">
                <Card className="stats-card text-center">
                    <div className="stat-number">
                        {standingsData?.raavg || 0}
                    </div>
                    <div className="stat-label">Average Runs Against</div>
                </Card>
            </Col>
            <Col md={4} sm={12} className="mb-3">
                <Card className="stats-card text-center">
                    <div className="stat-number">
                        {standingsData?.rdavg
                            ? standingsData.rdavg > 0
                                ? `+${standingsData.rdavg}`
                                : standingsData.rdavg
                            : 0}
                    </div>
                    <div className="stat-label">Average Run Differential</div>
                </Card>
            </Col>
        </Row>
    );
};

export default Stats;
